import React, { createContext, useContext } from "react";
import { notification as antdNotification } from "antd";
import { NotificationInstance } from "antd/es/notification/interface";

type NotificationContext = {
  messageApi: NotificationInstance;
};

export const NotificationContext = createContext<NotificationInstance>({
  success: () => {},
  error: () => {},
  info: () => {},
  warning: () => {},
  open: () => {},
  destroy: () => {},
});

export const NotificationContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [messageApi, contextHolder] = antdNotification.useNotification();

  return (
    <NotificationContext.Provider value={messageApi}>
      {children}
      {contextHolder}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  return useContext(NotificationContext);
};
